import { useCallback, useContext } from 'react';
import STORE from '../../../../store';
import AccountPickerContext from '../../../../contexts/AccountPickerContext';
import getExclusionConfigDocId from './getExclusionConfigDocId';

const useGetBonusRecordTaggingConfig = () => {
  const { selectedAccountId } = useContext(AccountPickerContext);

  return useCallback(
    async ({
      fieldType,
      fieldName,
      bonusProgramId,
    }: {
      fieldType: BonusRecordTagging.FieldType;
      fieldName: string;
      bonusProgramId: string;
    }) => {
      const config = await STORE.bonus
        .getBonusRecordTaggingConfigRef({
          docId: getExclusionConfigDocId({ fieldType, fieldName }),
          bonusProgramId,
          accountId: selectedAccountId,
        })
        .get();

      return config.data();
    },
    [selectedAccountId],
  );
};

export default useGetBonusRecordTaggingConfig;
